module.exports = __webpack_public_path__ + "img/check-sync.6312fa02.svg";